import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const SaudeCorporativa = lazy(() => import("../pages/solutions/SaudeCorporativa"));
const PainelGerenciador = lazy(() => import("../pages/solutions/PainelGerenciador"));
const GestaoAfastados = lazy(() => import("../pages/solutions/GestaoAfastados"));
const ImplantacaoAmbulatorios = lazy(() => import("../pages/solutions/ImplantacaoAmbulatorios"));
const MapeamentoNR1 = lazy(() => import("../pages/solutions/MapeamentoNR1"));
const TreinamentosNR = lazy(() => import("../pages/solutions/TreinamentosNR"));
const EntregadeEPI = lazy(() => import("../pages/solutions/EntregadeEPI"));
const AssistenciaMedica = lazy(() => import("../pages/solutions/AssistenciaMedica"));
const SaudeMental = lazy(() => import("../pages/solutions/SaudeMental"));
const Nexia = lazy(() => import("../pages/solutions/Nexia"));
const AgendamentoExames = lazy(() => import("../pages/agendamento-exames-ocupacionais/page"));
const PgrPcmso = lazy(() => import("../pages/pgr-pcmsco/page"));
const InstitucionalSst = lazy(() => import("../pages/institucional-sst/page"));
const GestaoAfastadosAbsenteismo = lazy(() => import("../pages/gestao-afastados-absenteismo/page"));
const SaudeMentalCorporativa = lazy(() => import("../pages/saude-mental-corporativa/page"));
const SobreNos = lazy(() => import("../pages/sobre/page"));
const NovidadesNexus = lazy(() => import("../pages/novidades/page"));
const Contato = lazy(() => import("../pages/contato/page"));
const AreaCliente = lazy(() => import("../pages/area-cliente/page"));
const AdminNovidades = lazy(() => import("../pages/admin/novidades/page"));
const NovidadesDetalhe = lazy(() => import("../pages/novidades/detalhe/page"));
const AdminPopups = lazy(() => import("../pages/admin/popups/page"));
const AdminPaginas = lazy(() => import("../pages/admin/paginas/page"));
const AdminHub = lazy(() => import("../pages/admin/page"));
const PoliticaPrivacidade = lazy(() => import("../pages/politica-privacidade/page"));
const Credenciado = lazy(() => import("../pages/credenciado/page"));
const Obrigado = lazy(() => import("../pages/obrigado/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre-nos",
    element: <SobreNos />,
  },
  {
    path: "/novidades-nexus",
    element: <NovidadesNexus />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/area-do-cliente",
    element: <AreaCliente />,
  },
  {
    path: "/solucoes/saude-corporativa",
    element: <SaudeCorporativa />,
  },
  {
    path: "/solucoes/painel-gerenciador",
    element: <PainelGerenciador />,
  },
  {
    path: "/solucoes/gestao-afastados",
    element: <GestaoAfastados />,
  },
  {
    path: "/solucoes/implantacao-ambulatorios",
    element: <ImplantacaoAmbulatorios />,
  },
  {
    path: "/solucoes/mapeamento-nr1",
    element: <MapeamentoNR1 />,
  },
  {
    path: "/solucoes/treinamentos-nr",
    element: <TreinamentosNR />,
  },
  {
    path: "/solucoes/entrega-epi",
    element: <EntregadeEPI />,
  },
  {
    path: "/solucoes/assistencia-medica",
    element: <AssistenciaMedica />,
  },
  {
    path: "/solucoes/saude-mental",
    element: <SaudeMental />,
  },
  {
    path: "/solucoes/nexia",
    element: <Nexia />,
  },
  {
    path: "/agendamento-exames-ocupacionais",
    element: <AgendamentoExames />,
  },
  {
    path: "/pgr-pcmsco",
    element: <PgrPcmso />,
  },
  {
    path: "/terceirizacao-sst",
    element: <InstitucionalSst />,
  },
  {
    path: "/gestao-afastados-absenteismo",
    element: <GestaoAfastadosAbsenteismo />,
  },
  {
    path: "/saude-mental-corporativa",
    element: <SaudeMentalCorporativa />,
  },
  {
    path: "/admin",
    element: <AdminHub />,
  },
  {
    path: "/admin/novidades",
    element: <AdminNovidades />,
  },
  {
    path: "/admin/popups",
    element: <AdminPopups />,
  },
  {
    path: "/admin/paginas",
    element: <AdminPaginas />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "/credenciado",
    element: <Credenciado />,
  },
  {
    path: "/obrigado-envio-formulario",
    element: <Obrigado />,
  },
  {
    path: "/novidades-nexus/:slug",
    element: <NovidadesDetalhe />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;